import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 10px 30px;
  position: relative;
`;

export const LogContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
`;

export const LogPrimary = styled.span`
  color: ${({ theme }) => theme.palette[850]};
  white-space: pre-wrap;
`;

export const LogDetails = styled.span<{ $muted?: boolean; $mono?: boolean }>`
  color: ${({ theme, $muted }) =>
    $muted ? theme.palette[650] : theme.palette[700]};
  font-size: 13px;
  line-height: 18px;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: ${({ $mono }) => ($mono ? "monospace" : "inherit")};
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
`;

export const UserName = styled.span`
  color: ${({ theme }) => theme.palette[850]};
  font-weight: 500;
`;

export const UserMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  color: ${({ theme }) => theme.palette[650]};
  font-size: 13px;
  line-height: 18px;

  & > span {
    color: ${({ theme }) => theme.palette[650]};
  }
`;

export const EmptyValue = styled.span`
  color: ${({ theme }) => theme.palette[650]};
`;
